export const HOMEPAGE = '/';
export const CONTACT = '/contact';

export const PROJECT_ROOT = '/projects/';
export const PROJECT = PROJECT_ROOT + ':slug';
export const GET_PROJECT = slug => PROJECT_ROOT + slug;



// WEBPACK FOOTER //
// ./src/constants/routesNames.js